import { PermissionsService } from '@services/auth/permissions.service';
import { Permission } from '@services/auth/authorization';
import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';
/**
 * Implements a directive that works similarly to the [Authorize] tag in C#
 *
 * @example //This will guard the content inside this div following the permissions defined for the user as GlobalSettings
 * <div appAuthorize="GlobalSettings"></div>
 */
@Directive({
  selector: '[appAuthorize]'
})
export class AuthorizeDirective implements OnInit {
  @Input() appAuthorize: Permission;

  constructor(private el: ElementRef, private renderer: Renderer2, private permissions: PermissionsService) {}

  ngOnInit() {
    // console.log(this.appAuthorize, this.permissions.getPermission(this.appAuthorize));
    switch (this.permissions.getPermission(this.appAuthorize)) {
      case 'N':
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        break;
      case 'R':
        this.renderer.setProperty(this.el.nativeElement, 'disabled', true);
        break;
      case 'W':
        // Shows the element, default is no-display
        break;
      default:
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
